export default new (class Logger {
    constructor() {
        this.debug = false;
        this.prefix = 'SocketService';
    }
    info(text, data = '') {
        this.log({ text, data });
    }
    error() {
        this.log({ type: 'error', data: { ...arguments } });
    }
    warn() {
        this.log({ type: 'error', data: { ...arguments } });
    }
    log({ type, text = '', data = '' }) {
        const message = `[${this.prefix}${type ? '/' + type : ''}]: ${text}`;
        this.debug && console[type || 'info'](message, data);
    }
})();
